import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ExpandableStandardCard } from './ExpandableStandardCard';
import { FMEACard } from './FMEACard';
import { CoreToolsCard } from './CoreToolsCard';
import { LeanSixSigmaCard } from './LeanSixSigmaCard';
import { TPMCard } from './TPMCard';
import { ESGCard } from './ESGCard';
import { getAllStandards } from '../../data/standards/standardsData';

export const StandardsGrid = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const standards = getAllStandards();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  return (
    <section ref={ref} className="py-16">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Explore Our ISO & IATF Standards
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Hover over each card to discover available training levels for each standard
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {standards.map((standard, index) => (
            <ExpandableStandardCard key={standard.slug} standard={standard} index={index} />
          ))}
          <FMEACard index={standards.length} />
          <CoreToolsCard index={standards.length + 1} />
          <LeanSixSigmaCard index={standards.length + 2} />
          <TPMCard index={standards.length + 3} />
          <ESGCard index={standards.length + 4} />
        </motion.div>
      </div>
    </section>
  );
};
